<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('campaign_details') }}
  div.text-sm.font-normal.basic600--text {{ $t('campaign_details_desc') }}

  v-form(ref="form")
    v-row.mt-6
      v-col(cols="12" sm="6")
        div.d-flex.align-center
          div.text-md.font-medium.basic700--text {{ $t('title') }}
          //- v-spacer
          //- div.text-xs.font-normal.basic600--text.mr-2 {{ name ? 200 - name.length : 200 }}
        v-text-field.text-md.font-normal.mt-2.round-xl(v-model="campaignData.title" :placeholder="$t('campaign_title')" outlined :rules="rules.not_empty" hide-details="auto" :maxlength="200")
      v-col(cols="12" sm="6")
        div.text-md.font-medium.basic700--text {{ $t('description_optional') }}
        v-text-field.text-md.font-normal.mt-2.round-xl(v-model="campaignData.description" :placeholder="$t('campaign_description')" outlined hide-details="auto")
      v-col(cols="12" sm="6")
        div.text-md.font-medium.basic700--text {{ $t('goal_optional') }}
        div.text-md.font-normal.basic600--text {{ $t('goal_desc') }}
        v-text-field.text-md.font-normal.mt-2.round-xl(v-model="campaignData.goal_amount" type="number" placeholder="10,000" :prefix="$currency.symbol" outlined hide-details="auto")
      v-col(cols="12" sm="6")
        div.text-md.font-medium.basic700--text {{ $t('campaign_end_date') }}
        div.text-md.font-normal.basic600--text {{ $t('campaign_end_date_desc') }}
        y-dialog(v-model='showPicker' width='320px')
          template(v-slot:activator='{ on }')
            yc-text-field.text-md.font-normal.mt-2.round-xl(:value="endDate" :label="$t('date_selection')" outlined hide-details="auto" readonly :calendar="true" :on='on')
          v-card
            v-card-text.px-2.pt-2.pb-0
              yc-date-picker(:parentDate.sync="campaignData.end_date" color="info")
            v-card-actions.px-4.pb-4
              v-row(no-gutters)
                v-col.pr-2
                  v-btn.round-lg.heading-6(color="basic700" block dark outlined depressed @click="clearDate") {{ $t('clear') }}
                v-col.pl-2
                  v-btn.round-lg.heading-6(color="info500" block dark depressed :dark="Boolean(campaignData.end_date)" :disabled="!campaignData.end_date" @click="pickDate") {{ $t('select') }}

  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(color="info500" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DetailsCampaign',
  data () {
    return {
      isLoading: false,
      campaignData: {},
      endDate: null,
      showPicker: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    })
  },
  mounted () {
    if (this.campaign) {
      this.setData(this.campaign)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (campaign) {
      this.campaignData = campaign
      if (campaign.goal_amount) {
        this.$set(this.campaignData, 'goal_amount', campaign.goal_amount/this.$currency.multiplier)
      }
      if (this.campaignData.end_date) {
        this.endDate = this.$options.filters.displayDate(this.campaignData.end_date)
      }
    },
    pickDate () {
      this.endDate = this.$options.filters.displayDate(this.campaignData.end_date)
      this.showPicker = false
    },
    clearDate () {
      this.campaignData.end_date = null
      this.endDate = null
      this.showPicker = false
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        title: this.campaignData.title,
        form: { status: 'published' },
        description: this.campaignData.description,
        goal_amount: this.campaignData.goal_amount ? this.campaignData.goal_amount * this.$currency.multiplier : null,
        end_date: this.campaignData.end_date,
      }
      this.$axios.patch(`/donations/${this.company.slug}/campaigns/${this.campaign.form.slug}`, data)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>